<srp-loading></srp-loading>
<div [class]="className">
    <div class="header">
        @if(showHeader) {
            <srp-header [appContext]="'SRP'"></srp-header>
        }
    </div>
    @if(showSubHeader) {
        <div class="sub-header">
            <srp-sub-header></srp-sub-header>
        </div>
    }
    <div class="content" cdkScrollable [ngClass]="{'srp-content-scrollable': showSubHeader}">
        <router-outlet></router-outlet>
    </div>
    <div class="footer">
        @if(showFooter) {

        <srp-footer></srp-footer>
        }
    </div>

</div>
